var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompose = function SvgCompose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#121212",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.222 6.943v15.843h15.843v-9.773h-.778v8.995H7V7.72h8.72v-.778z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.197 4.667-8.586 8.586-.626 3.556 3.548-.635 8.586-8.585-2.922-2.922zm-7.863 8.962 7.863-7.863 1.822 1.823-7.863 7.862-2.212.395.39-2.217z"
  }))));
};
export { SvgCompose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiMxMjEyMTIiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTYuMjIyIDYuOTQzdjE1Ljg0M2gxNS44NDN2LTkuNzczaC0uNzc4djguOTk1SDdWNy43Mmg4Ljcydi0uNzc4eiIvPgogICAgICAgIDxwYXRoIGQ9Im0yMS4xOTcgNC42NjctOC41ODYgOC41ODYtLjYyNiAzLjU1NiAzLjU0OC0uNjM1IDguNTg2LTguNTg1LTIuOTIyLTIuOTIyem0tNy44NjMgOC45NjIgNy44NjMtNy44NjMgMS44MjIgMS44MjMtNy44NjMgNy44NjItMi4yMTIuMzk1LjM5LTIuMjE3eiIvPgogICAgPC9nPgo8L3N2Zz4K";